import React, { Component } from 'react'
import WmsCollapse from '../../../components/WmsCollapse/WmsCollapse.jsx'
import WmsInput from '../../../components/WmsInput/WmsInput.jsx'

export class StallionAccountInfoComponent extends Component {
    constructor(props) {
        super(props)

        this.translate = window.translate;
        this.$rootScope = window;

        this.state = {

        }
    }

    render() {
        return (
            <WmsCollapse
                id={"stallionAccountInfoScreen"}
                headerLabel={this.translate("Label_Account_Information")}
                showCollapseText={false}
                showCollapseIcon={false}
            >
                <div className="account-info-section">
                    <div>
                        <WmsInput
                            id="nickname"
                            inputName="Nickname"
                            wmsSelector={this.props.selector + "nickname"}
                            onChangeFunc={this.props.handleCarrierObjChange}
                            label={this.translate("Label_Account_Nick_Name")}
                            value={this.props.currentCarrierObj.Nickname}
                            required={true}
                        />
                        <WmsInput
                            id="accountNumber"
                            inputName="AccountNumber"
                            wmsSelector={this.props.selector + "accountNumber"}
                            onChangeFunc={this.props.handleCarrierObjChange}
                            label={this.translate('Label_Account_Number')}
                            value={this.props.currentCarrierObj.AccountNumber}
                            required={true}
                        />
                        <WmsInput
                            id="apiKey"
                            inputName="ApiKey"
                            wmsSelector={this.props.selector + "apiKey"}
                            onChangeFunc={this.props.handleCarrierObjChange}
                            label={this.translate("Label_API_Key")}
                            value={this.props.currentCarrierObj.ApiKey}
                            required={true}
                        />
                    </div>
                </div>
            </WmsCollapse>
        )
    }
}
